<script setup lang="ts">
/**
 * Aura Incorporation — Details of Foreign Director / Shareholder.
 *
 * T-Link 이사/주주 중 **외국 국적자**는 syncAuraDocs 가 fp{N}_* 키로 자동 채운다.
 * 여기서는 그렇게 채워진 행 수만큼 표를 늘려 보여주고, 추가 인원은 수동으로 Add 할 수 있다.
 */
import { computed, inject, ref, watch } from 'vue';
import CddVarField from './cdd/CddVarField.vue';
import { CDD_FILL } from './cdd/useCddFill';
import './allotDoc.css';

const fill = inject(CDD_FILL, null);

const rows = ref<number[]>([1]);
function addRow() { rows.value.push((rows.value[rows.value.length - 1] || 0) + 1); }
function removeRow(id: number) { if (rows.value.length > 1) rows.value = rows.value.filter((r) => r !== id); }

/** 자동 채움으로 값이 들어온 fp 행의 최대 번호 */
const autoRowCount = computed(() => {
  const values = fill?.values || {};
  let max = 0;
  for (const k of Object.keys(values)) {
    const m = /^fp(\d+)_foreign_person_name$/.exec(k);
    if (m && String(values[k] ?? '').trim()) max = Math.max(max, Number(m[1]));
  }
  return max;
});

// 외국인이 자동 감지되면 그 수만큼 행을 확보 (수동 추가분은 그대로 유지)
watch(
  autoRowCount,
  (n) => {
    while (rows.value.length < n) rows.value.push(rows.value.length + 1);
  },
  { immediate: true },
);
</script>

<template>
  <div class="allot-doc">
    <div class="doc-lbl-title" style="text-align:center">DETAILS OF FOREIGN DIRECTOR / SHAREHOLDER</div>
    <table class="cdd-tbl" style="margin-top:10px">
      <thead>
        <tr>
          <th style="width:6%">No.</th>
          <th>Name of Director/Shareholder</th>
          <th>Passport / FIN No.</th>
          <th>Date of Expiry</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(id, i) in rows" :key="id">
          <td>{{ i + 1 }}</td>
          <td><CddVarField :field-key="`fp${id}_foreign_person_name`" label="Foreign Person Name" /></td>
          <td><CddVarField :field-key="`fp${id}_foreign_person_passport_fin_no`" label="Foreign Person Passport / FIN No." /></td>
          <td><CddVarField :field-key="`fp${id}_foreign_person_date_of_expiry`" label="Foreign Person Date of Expiry" /></td>
          <td>
            <CddVarField :field-key="`fp${id}_foreign_person_action`" label="Foreign Person Action" />
            <button v-if="rows.length > 1" class="cdd-rowbtn" title="Remove" @click="removeRow(id)">✕</button>
          </td>
        </tr>
      </tbody>
    </table>
    <button class="cdd-addrow" @click="addRow">＋ Add foreign person</button>
  </div>
</template>
